module.exports = __webpack_public_path__ + "img/avatar.dafe428e.jpg";